import Vue from 'vue'
import VueRouter from 'vue-router'
// 无侧栏布局
import Index from '@/views/Index/index.vue'
Vue.use(VueRouter)

export const constantRouterMap = [{
  path: '/login',
  name: 'login',
  component: () => import(/* webpackChunkName: "login" */ '@/views/Login/index.vue'),
  hidden: true
},
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/Other/404.vue')
  },
  {
    path: '/unlogin',
    name: '401',
    component: () => import(/* webpackChunkName: "401" */ '@/views/Other/401.vue')
  },
  {
    path: '/index/:id?',
    name: 'index',
    meta: '新首页',
    component: Index
  },
  {
    path: '/warn/:id?',
    component: () => import('@/views/Layout/index.vue'),
    name: 'warn',
    meta: '异常列表',
    hidden: true
  },
  {
    path: '/',
    redirect: '/index/:id?',
    component: () => import('@/views/Layout/index.vue'),
    hidden: true,
    children: [{
      path: '/dailyDuty/:id?',
      component: () => import('@/views/DailyDuty/index.vue'),
      name: 'dailyDuty',
      meta: '日常值守'
    },
      {
        path: '/deviceManagement/:id?',
        component: () => import('@/views/DeviceManagement/index.vue'),
        name: 'deviceManagement',
        meta: '站点管理'
      },
      {
        path: '/operation/:id?',
        component: () => import('@/views/Operation/index1.vue'),
        name: 'operation',
        meta: '运营统计'
      },
      {
        path: '/miBicycle/:id?',
        // name: '恒风巡查',
        component: () => import('@/views/MiBicycle/index.vue'),
        name: 'miBicycle',
        meta: '恒风巡查主页'
      },
      {
        path: '/ratingEvaluation/:id?',
        component: () => import('@/views/ratingEvaluation/index.vue'),
        name: 'ratingEvaluation',
        meta: '评分评价',
        redirect: '/ratingEvaluation/rate/:id?',
        children: [{
          path: '/ratingEvaluation/rate/:id?',
          component: () => import('@/views/RouteView.vue'),
          redirect: '/ratingEvaluation/rate/index/:id?',
          children: [{
            path: '/ratingEvaluation/rate/index/:id?',
            component: () => import('@/views/ratingEvaluation/rate.vue'),
            name: 'rate',
            meta: '企业测评'
          },
            {
              path: '/ratingEvaluation/rate/grade/:id?&:data?',
              component: () => import('@/views/ratingEvaluation/Grade.vue'),
              name: 'grade',
              meta: '测评详情'
            }]
        },
          {
            path: 'setting/:id?',
            component: () => import('@/views/ratingEvaluation/setting.vue'),
            name: 'setting',
            meta: '测评设置'
          }]
      },
      {
        path: '/companyManagement/:id?',
        component: () => import('@/views/CompanyManagement/index.vue'),
        name: 'companyManagement',
        meta: '企业管理',
        redirect: '/companyManagement/company/:id?',
        children: [{
          path: 'company/:id?',
          component: () => import('@/views/CompanyManagement/company.vue'),
          name: 'company',
          meta: '企业管理'
        }, {
          path: 'sum/:id?',
          component: () => import('@/views/CompanyManagement/sum.vue'),
          name: 'sum',
          meta: '总量设置'
        }, {
          path: 'check/:id?',
          component: () => import('@/views/CompanyManagement/check.vue'),
          name: 'check',
          meta: '区域核定量设置'
        }, {
          path: 'siteSync/:id?',
          component: () => import('@/views/CompanyManagement/siteSync.vue'),
          name: 'siteSync',
          meta: '站点同步'
        }, {
          path: 'dispatchSync/:id?',
          component: () => import('@/views/CompanyManagement/dispatchSync.vue'),
          name: 'dispatchSync',
          meta: '调度信息'
        }, {
          path: 'requestSync/:id?',
          component: () => import('@/views/CompanyManagement/requestSync.vue'),
          name: 'requestSync',
          meta: '租还信息'
        }, {
          path: 'bikeSync/:id?',
          component: () => import('@/views/CompanyManagement/bikeSync.vue'),
          name: 'bikeSync',
          meta: '车辆信息'
        },
          {
            path: 'bikeOutSideFee/:id?',
            component: () => import('@/views/CompanyManagement/bikeOutSideFee.vue'),
            name: 'bikeOutSideFee',
            meta: '站外还车扣费'
          }, {
            path: 'bikeRideOrder/:id?',
            component: () => import('@/views/CompanyManagement/bikeRideOrder.vue'),
            name: 'bikeRideOrder',
            meta: '骑行订单信息'
          }, {
            path: 'operationalReport/:id?',
            component: () => import('@/views/CompanyManagement/operationalReport.vue'),
            name: 'operationalReport',
            meta: '运营报表'
          }
        ]
      },
      {
        path: '/inforManagement/:id?',
        component: () => import('@/views/InforManagement/index.vue'),
        name: 'inforManagement',
        meta: '资料管理主页'
      },
      {
        path: '/systemSettings/:id?',
        component: () => import('@/views/SystemSettings/index.vue'),
        name: 'systemSettings',
        meta: '系统设置'
      },
      {
        path: '/regionalSettings/:id?',
        component: () => import('@/views/RegionalSettings/index.vue'),
        meta: '区域设置',
        name: 'regionalSettings'
      },
      {
        path: '/blackListManagement/:id?',
        component: () => import('@/views/BlackListManagement/index.vue'),
        meta: '失信管理',
        name: 'blackListManagement'
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: constantRouterMap
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
